import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs, siteMeta } from "@/mocks/chigua";
import SectionHeading from "@/components/chigua/SectionHeading";
import JsonLd from "@/components/chigua/JsonLd";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section className="border-b border-background-200 bg-background-100/40" id="faq">
      <JsonLd data={schema} />
      <div className="mx-auto max-w-[1100px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="吃瓜指南"
          title="关于内幕消息，你常问的这些"
          desc="关于内容真实性、内幕消息与内幕真相的区别、传闻如何甄别，我们把最高频的问题一次讲清楚。"
          action="联系我们"
          actionTo="/contact"
        />
        <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div key={f.q} className={i !== faqs.length - 1 ? "border-b border-background-100" : ""}>
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="flex w-full items-start justify-between gap-4 px-5 py-5 text-left transition hover:bg-background-100/60 md:px-7"
                  aria-expanded={open}
                >
                  <span className="flex items-start gap-3">
                    <span className={`mt-0.5 grid h-6 w-6 shrink-0 place-items-center rounded-full text-xs font-bold ${open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"}`}>
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-heading text-[15px] font-bold text-foreground-950 md:text-base">{f.q}</span>
                  </span>
                  <i className={`ri-add-line mt-1 text-lg text-foreground-500 transition ${open ? "rotate-45" : ""}`} aria-hidden="true" />
                </button>
                <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-6 pl-[3.5rem] text-sm leading-7 text-foreground-600 md:px-7 md:pl-[4rem]">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <p className="mt-5 text-center text-sm text-foreground-500">
          仍有疑问？欢迎来信：<a href={`mailto:${siteMeta.email}`} className="font-medium text-primary-600 underline-offset-2 hover:underline" rel="nofollow">{siteMeta.email}</a>
        </p>
      </div>
    </section>
  );
}